import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aether_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Response interceptor — normalizes FastAPI Pydantic validation errors
// (which arrive as `detail: [{type, loc, msg, input, ctx, url}, ...]`)
// into a readable string BEFORE the error is thrown to the caller. This
// prevents React from ever trying to render a raw error object as a
// child (which crashes with "Objects are not valid as a React child").
//
// Rules:
//   - detail = "already a string" → left alone
//   - detail = [ {msg, loc: [...]}, ... ] → joined into "Field: msg" list
//   - detail = anything else → JSON-stringified
api.interceptors.response.use(
  (r) => r,
  (err) => {
    try {
      const d = err?.response?.data?.detail;
      if (Array.isArray(d)) {
        const parts = d.map((e) => {
          if (!e || typeof e !== "object") return String(e);
          const msg = e.msg || "invalid input";
          const loc = Array.isArray(e.loc) ? e.loc.filter(
            (x) => x !== "body" && x !== "query" && x !== "path",
          ).join(".") : "";
          return loc ? `${loc}: ${msg}` : msg;
        });
        err.response.data.detail = parts.join(" · ").slice(0, 500);
      } else if (d && typeof d === "object") {
        err.response.data.detail = (
          d.msg || d.message || JSON.stringify(d)
        ).toString().slice(0, 500);
      }
    } catch (_e) {
      // Never let the interceptor mask the original error — just pass through.
    }
    return Promise.reject(err);
  },
);

export function setToken(token) {
  if (token) localStorage.setItem("aether_token", token);
  else localStorage.removeItem("aether_token");
}

export function getToken() {
  return localStorage.getItem("aether_token");
}
